<!-- <input type="text" placeholder="Search icons..." (input)="onSearchChange($event)" /> -->
<div class="w-100 d-flex div-direction">
    <div class="w-100 d-flex">
        <input type="text" value="{{ searchTerm }}" placeholder="Search icons..." (keyup)="setSearch($event)"
        class="form-control form-search w-100" (keydown.enter)="$event.preventDefault()" #input />
        <button (click)="onSearchChange()" type="button" class="btn btn-default btn-search" id="search-box-inner-form">
            <i class="icon-search"></i>
        </button>
    </div>
    <div class="w-100 d-flex content-align">
        <button type="button" class="btn btn-default button-bottom" (click)="showOutlinedIcons()" [ngClass]="{ 'button-selected': isOutLined }" >Outlined Icons</button>
        <div class="color-box-group color-box01">
          </div>
          <div class="color-box-group color-box02">
            <div
              id="color-picker-text-color"
              class="input-group colorpicker-component"
            >
              <span class="text-color">Icon Color:</span>
              <span class="input-group-addon"
                ><input
                  class="custom-color-picker"
                  [(colorPicker)]="iconColor"
                  [style.background]="iconColor"
                  (colorPickerChange)="colorChange($event)"
                  [style.color]="iconColor"
                />
              </span>
            </div>
          </div>
    </div>
</div>

<div class="icon-container" [ngStyle]="{ 'height': height+'px'}">
  <div *ngFor="let icon of displayedIcons" class="icon" [ngStyle]="{ 'background-color':bgColorDefault, 'color': iconColor}" [ngClass]="{ 'selected-icon':form.value.Icon === getIconClass(icon) }" (click)="iconSelected(icon)">
    <i [ngStyle]="{'font-size':fontSize+'px'}" [class]="getIconClass(icon)" [title]="getTitle(icon)"></i>
  </div>
</div>

<div class="load-more d-flex">
    <button type="button" class="btn btn-default custom-button" *ngIf="lastLoadedIndex < icons.length" (click)="onScroll()">Load more</button>
</div>